<template>
  <div class="split d-flex">
    <div class="left">
      <SlideNav class="nav-test">
        <template v-slot="model">
          <div class="nav-flex">
            <div
              :class="{ disabled: !canAdd }"
              @click="addNewSlide()"
              v-on:keyup.enter="addNewSlide()"
              tabindex="0"
              class="slide-action add-slide"
            >
              <I name="plus-circle"></I>
              <div class="hoverText nobreak">Ny sida</div>
            </div>
            <div
              :class="{ disabled: !canMoveLeft }"
              @click="moveLeft()"
              class="slide-action move-left"
            >
              <I name="undo"></I>
              <div class="hoverText nobreak">Flytta vänster</div>
            </div>
            <div
              :class="{ disabled: !canMoveRight }"
              @click="moveRight()"
              class="slide-action move-right"
            >
              <I name="redo"></I>
              <div class="hoverText nobreak">Flytta höger</div>
            </div>
            <div
              :class="{ disabled: !canDelete }"
              @click="deleteSlide(model.currentSlide)"
              class="slide-action delete-slide"
            >
              <I name="trash2"></I>
              <div class="hoverText nobreak">
                Radera sida {{ model.currentSlide }}
              </div>
            </div>
          </div>
        </template>
      </SlideNav>

      <div v-if="currentSlide === 0">
        <Preferences />
      </div>
      <div v-else>
        <SlideContent
          v-for="(slide, index) in slides"
          v-if="loaded && currentSlide === index + 1"
          :slide="slide"
          :slideIndex="index"
          :key="index"
        ></SlideContent>
      </div>
    </div>

    <div class="right z2">
      <div v-if="showPreview" class="preview-container">
        <div class="preview-header">
          <span class="item-container items-title">Förhandsgranska</span>
          <!-- <span class="enlarge-icon"><I name="expand2"></I></span> -->
        </div>
        <ShowSlides
          v-if="loaded"
          mode="preview"
          :show-comments="commentsOpen"
          @showComments="(e) => (commentsOpen = e)"
        ></ShowSlides>
        <SlideButtons />

        <div v-if="currentSlide > 0">
          <Notes :currentSlide="currentSlide" />
        </div>

        <div
          @click="savePresentation()"
          class="button button-secondary create-button"
        >
          Gå till {{ type }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Component, Vue, Watch } from 'vue-property-decorator';
import CompanySelection from '@/components/CompanySelection';
import SlideContent from '@/components/simpleSlide/SlideContent.vue';
import YearEnd from '@/components/simpleSlide/templates/YearEnd.vue';
import TemplateSelection from '@/views/TemplateSelection';
import deck from '@/store/modules/deck';
import ShowSlides from '@/components/simpleSlide/components/ShowSlides.vue';
import SlideNav from '@/components/simpleSlide/components/SlideNav.vue';
import user from '@/store/modules/user';
import SlideButtons from '@/components/simpleSlide/components/SlideButtons.vue';
import Preferences from '@/components/simpleSlide/Preferences.vue';
import Notes from '@/components/simpleSlide/components/Notes.vue';

export default {
  name: 'CreateSlides',
  components: {
    Preferences,
    SlideButtons,
    ShowSlides,
    CompanySelection,
    SlideContent,
    YearEnd,
    TemplateSelection,
    SlideNav,
    Notes,
  },

  data() {
    return {
      basedOn: '',
      title: 'Presentation',
      template: false,
      includeComment: false,
      companyBased: null,
      linkedCompany: null,
      loaded: false,
      commentsOpen: false,
    };
  },

  async mounted() {
    await deck.loadFull({
      blobId: this.$route.params.DocumentId,
      internal: false,
      editable: true,
    });
    this.loaded = true;
    // await deck.reloadData(false);
  },

  async beforeRouteLeave(to, from, next) {
    if (await deck.isDirty()) {
      await deck.save();
      await user.getUser('Uppdaterar ' + this.type);
    }
    next();
  },

  computed: {
    slides() {
      return JSON.parse(JSON.stringify(deck.Slides));
    },
    showPreview() {
      return deck.Slides.length > 0;
    },
    currentSlide() {
      return deck.nav.currentSlide;
    },
    currentSlideItem() {
      return deck.Slides[deck.nav.currentSlide - 1];
    },
    canAdd() {
      return true;
    },
    canMoveLeft() {
      return this.currentSlide > 2 && this.currentSlide < this.slides.length;
    },
    canMoveRight() {
      return (
        this.currentSlide > 1 && this.currentSlide < this.slides.length - 1
      );
    },
    canDelete() {
      return (
        this.currentSlide !== 0 &&
        this.currentSlide !== 1 &&
        this.currentSlide !== this.slides.length
      );
    },
    currentCommentLength() {
      const slide = this.slides[this.currentSlide - 1];
      const comment = slide ? slide.comment : '';
      return comment ? comment.length : 0;
    },
    type() {
      return deck.Type === 'deck-template' ? 'mall' : 'presentation';
    },
  },

  methods: {
    toggleComments(open) {
      this.commentsOpen = open;
    },
    createPresentation() {
      this.addSlide('slideTitle', 'Presentation');
    },

    addSlide(type, title) {
      if (!this.canAdd) {
        return;
      }
      const slide = {
        slideType: type ? type : null,
        title: title ? title : null,
        comment: '',
      };
      deck.addSlide(slide);
      deck.setCurrentSlide(deck.nav.currentSlide + 1);
    },

    addNewSlide() {
      this.addSlide();
    },

    moveLeft() {
      if (this.canMoveLeft) {
        deck.moveSlideLeft(this.currentSlide - 1);
        deck.setCurrentSlide(this.currentSlide - 1);
      }
    },

    moveRight() {
      if (this.canMoveRight) {
        deck.moveSlideRight(this.currentSlide - 1);
        deck.setCurrentSlide(this.currentSlide + 1);
      }
    },

    deleteSlide(i) {
      if (this.canDelete) {
        deck.deleteSlide(i - 1);
      }
    },

    async savePresentation() {
      if (await deck.isDirty()) {
        await deck.save();
        await user.getUser('Uppdaterar ' + this.type);
      }
      if (deck.Type === 'deck-template') {
        this.$router.push({
          name: 'templates',
          params: { OrgNr: deck.OrgNr },
        });
      } else {
        this.$router.push({
          name: 'documents',
          params: { OrgNr: deck.OrgNr },
        });
      }
    },

    openFullscreen() {
      const elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
      // this.isFullscreen = true;
    },

    updateComment() {
      const slide = this.slides[deck.nav.currentSlide - 1];
      deck.updateSlide({
        slide,
        index: deck.nav.currentSlide - 1,
      });
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
input {
  accent-color: col('colors.Primary');
  margin-top: 1rem;
  border: 1px solid col('colors.LightGrey');
  padding: 0.2rem 0.5rem;

  &:focus {
    outline-color: col('colors.Secondary');
    background-color: rgba(col('colors.Secondary'), 0.15);
  }
}

label {
  margin: 1rem 2rem 1rem 0.5rem;
}

details + details {
  margin-top: 1rem;
}

.flex-one {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.flex-two {
  flex: 2;
  display: flex;
  flex-direction: column;
}

.question-container {
  padding: 1rem;
  border: 1px solid col('colors.Light');
  background-color: col('colors.Light');
  transition: 0.5s;

  &:focus-within {
    border-color: col('colors.Primary');
    background-color: rgba(col('colors.White'), 1);
  }
}

.edit-content {
  display: flex;
  flex-direction: row;
  gap: 2rem;
}

.mb-10 {
  margin-bottom: 1rem;
}

.button {
  width: 50%;
  margin: 2rem auto;
}

.preview-container {
  position: sticky;
  top: 2rem;
  overflow-x: hidden;
  max-width: 100%;
}

.preview-header {
  // margin-top: 2rem;
  margin-bottom: 1rem;
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 15vw;
  width: calc(60vw - 5rem + 1px);
  background: linear-gradient(0deg, col('colors.Light'), transparent);
}

input[type='radio'] {
  width: 1rem;
  height: 1rem;
}

.create-button {
  position: fixed;
  bottom: 0;
  width: calc(25vw * 0.9);
  margin-left: calc(25vw * 0.05 + 0.5rem);
  display: flex;
  justify-content: center;
}

.show-button {
  position: fixed;
  bottom: 0;
  width: calc(10vw * 0.9);
  margin-left: calc(25vw * 0.05 - 0.5rem);
  display: flex;
  justify-content: center;
}

.addSlide {
  background-color: col('colors.Tertiary');
  width: 8rem;
  color: col('colors.Black');
  font-weight: 600;
  padding: 0.75rem 2rem;
  text-align: center;
  border: 1px solid col('colors.Black');
  border-radius: 0.3rem;
  transition: 0.5s;

  &:hover {
    cursor: pointer;
    box-shadow: 0 0 1rem 0 col('colors.DarkGrey');
    background-color: lighten(col('colors.Tertiary'), 7.5%);
  }
}

.adjust-01 {
  margin: 0;
  padding: 0;
  padding-left: 1.75rem;
}

.comment {
  width: 100%;
  accent-color: col('colors.Primary');
  margin-top: 0.5rem;
  padding: 0.2rem 0.5rem;
  border: 1px solid col('colors.DarkGrey');
  background-color: col('colors.Light');

  &:focus {
    background-color: col('colors.White');
    outline: none;
  }
}

.character-counter {
  text-align: right;
}

.button-disabled {
  color: col('colors.DarkGrey');

  &:hover {
    cursor: not-allowed;
    box-shadow: none;
  }
}

.z2 {
  z-index: 2;
}

.enlarge-icon {
  position: absolute;
  top: 0;
  right: 0;

  &:hover {
    cursor: pointer;
    color: col('colors.Secondary');
  }
}

.slide-action {
  bottom: 2rem;
  right: 0;
  width: 3rem;
  height: 3rem;
  background-color: col('colors.White');
  padding: 0.5rem;
  border: 1px solid col('colors.LightGrey');
  border-radius: 0.3rem;
  overflow: hidden;
  transition: 0.5s;

  &:hover {
    &.add-slide {
      background-color: col('colors.Tertiary');
      color: col('colors.Black');
    }

    &.delete-slide {
      background-color: col('colors.Negative');
    }

    &.move-left {
      background-color: col('colors.Secondary');
    }

    &.move-right {
      background-color: col('colors.Secondary');
    }

    width: 10rem;
    cursor: pointer;
    border-color: col('colors.Black');
    color: col('colors.White');
    font-weight: 600;
    box-shadow: 0 0 1rem 0 col('colors.DarkGrey');
  }
}

.slide-action + .slide-action {
  margin-left: 0.5rem;
}

.add-slide {
  width: 10rem;
  font-weight: 600;
  background-color: col('colors.Tertiary');
  border: 1px solid col('colors.DarkGrey');
}

.nav-flex:has(:hover) .add-slide:not(:hover) {
  width: 3rem;
  background-color: col('colors.White');
  border-color: col('colors.LightGrey');
}

.nav-flex {
  display: flex;
}

.hoverText {
  position: relative;
  top: -1.75rem;
  left: 1.5rem;
  margin-left: 1rem;
  min-width: 6rem;
}

.slide-action.disabled {
  color: col('colors.LightGrey');
  background-color: col('colors.Light');
  &:hover {
    cursor: not-allowed;
    width: 3rem;
    color: col('colors.LightGrey');
    background-color: col('colors.Light');
    box-shadow: none;
    border-color: col('colors.LightGrey');
  }
}

.nav-flex:has(.disabled:hover) .add-slide:not(:hover) {
  width: 10rem;
  background-color: col('colors.Tertiary');
  border-color: col('colors.DarkGrey');
}
</style>
